import httpClient from '../../services/httpClient';

export interface TopUpDenomination { id?: number; name: string; description: string; price: number; picture?: string; region: 'Turkey' | 'India'; currency: 'TRY' | 'INR'; faceValue: number; isAvailable: boolean; }
export interface TopUpCard { id: number; name: string; description: string; price: number; picture: string; denominations: TopUpDenomination[]; }
export type TopUpCardPayload = Omit<TopUpCard, 'id' | 'picture'> & { picture?: string };

const normalizeCard = (card: any): TopUpCard => ({
  id: Number(card?.id ?? 0),
  name: String(card?.name ?? ''),
  description: String(card?.description ?? ''),
  price: Number(card?.price ?? 0),
  picture: String(card?.picture ?? ''),
  denominations: Array.isArray(card?.denominations) ? card.denominations : [],
});

export const topUpCardService = {
  list: async () => { const { data } = await httpClient.get('/api/TopUpCard', { params: { pageSize: 100 } }); const items = data?.products ?? data ?? []; return Array.isArray(items) ? items.map(normalizeCard) : []; },
  get: async (id: number) => { const { data } = await httpClient.get(`/api/TopUpCard/${id}`); return normalizeCard(data); },
  create: async (payload: TopUpCardPayload) => { const { data } = await httpClient.post('/api/Admin/TopUpCards', payload); return data as TopUpCard; },
  update: async (id: number, payload: TopUpCardPayload) => { const { data } = await httpClient.put(`/api/Admin/TopUpCards/${id}`, payload); return data as TopUpCard; },
  remove: async (id: number) => { await httpClient.delete(`/api/Admin/TopUpCards/${id}`); },
  uploadImage: async (id: number, file: File) => { const fd = new FormData(); fd.append('file', file); const { data } = await httpClient.post(`/api/Images/master/${id}`, fd); return String(data?.url ?? ''); },
};
